/**
 * Modal
 */

const Modal = (function($) {
  "use strict";

  const $body = $("body");
  const $modal = $(".Modal");

  function openModal(e) {
    e.preventDefault();
    $body.addClass("is-fixed");
    $modal.attr("aria-hidden", "false").attr("tabindex", "0");
  }

  function closeModal(e) {
    if (!e.keyCode || e.keyCode === 27) {
      e.preventDefault();
      $body.removeClass("is-fixed");
      $modal.attr("aria-hidden", "true").attr("tabindex", "-1");
    }
  }

  function initModal() {
    $(".js-modal-open").on("click", openModal);
    $(".js-modal-close").on("click", closeModal);
    $modal.on("click", closeModal);
    $modal.on("click", ".Modal-inner", function(e) {
      e.stopPropagation();
    });
    $(document).on("keydown", closeModal);
  }

  function init() {
    // return early if no corresponding module present
    if (!$(".Modal").length) {
      return;
    }

    initModal();
  }

  return {
    init
  };
})(jQuery);

jQuery(document).ready(Modal.init);
